export default "__VITE_ASSET__DM3XsL58__"